import React from 'react';
import css from './WaitingRoomFooter.css';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import { Icon as SemanticIcon } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { getWord } from 'utils/tenant';

function WaitingRoomFooter(props) {

  const getButtonTitle = isLocked => isLocked ? 'This action is unavailable to you.' : null;

  return (
    <footer className={css['container']}>
      <StyledButton
        asLink
        dataRole='addOfficeHoursWR' 
        title={getButtonTitle(props.userCalendarIsLocked)} 
        aria-disabled={props.userCalendarIsLocked} 
        onClick={() => {
          if (props.userCalendarIsLocked) return;
          props.openAddOfficeHoursModal();
        }}>
        <span>
          <Icon icon='access_time' aria-hidden='true'/>
          <Icon icon='add' aria-hidden='true' className={css['plus-icon']} />
          Office Hours
        </span>
      </StyledButton>
      <StyledButton 
        asLink 
        dataRole='addAppointmentWR'
        title={getButtonTitle(props.userCalendarIsLocked && !props.managesUnlockedCalendar)} 
        aria-disabled={props.userCalendarIsLocked && !props.managesUnlockedCalendar}
        onClick={() => {
          if (props.userCalendarIsLocked && !props.managesUnlockedCalendar) return;
          props.openAddAppointmentModal();
        }}>
        <span>
          <Icon icon='insert_invitation' aria-hidden='true' />
          <Icon icon='add' aria-hidden='true' className={css['plus-icon']} />
          Appointment
        </span>
      </StyledButton>
      <StyledButton 
        asLink 
        dataRole='addWalkinWR'
        title={getButtonTitle(props.userCalendarIsLocked && !props.managesUnlockedCalendar)} 
        aria-disabled={props.userCalendarIsLocked && !props.managesUnlockedCalendar}
        onClick={() => {
          if (props.userCalendarIsLocked && !props.managesUnlockedCalendar) return;
          props.openAddWalkInModal();
        }}>
        <span>
          <Icon icon='directions_walk' aria-hidden='true' />
          <Icon icon='add' aria-hidden='true' className={css['plus-icon']} />
          {getWord('dropIn', false)}
        </span>
      </StyledButton>
      <StyledButton 
        asLink 
        dataRole='addGroupSessionWR'
        title={getButtonTitle(props.userCalendarIsLocked)} 
        aria-disabled={props.userCalendarIsLocked} 
        onClick={() => {
          if (props.userCalendarIsLocked) return;
          props.openAddGroupSessionModal();
        }}>
        <span>
          <Icon icon='group' aria-hidden='true' />
          <Icon icon='add' aria-hidden='true' className={css['plus-icon']} />
          Group Session
        </span>
      </StyledButton>
      <StyledButton 
        asLink 
        dataRole='addReserveTimeWR'
        title={getButtonTitle(props.userCalendarIsLocked)} 
        aria-disabled={props.userCalendarIsLocked} 
        onClick={() => {
          if (props.userCalendarIsLocked) return;
          props.openReserveTimeModal();
        }}>
        <span>
          <Icon icon='event_available' aria-hidden='true'/>
          <Icon icon='add' aria-hidden='true' className={css['plus-icon']} />
          Reserve Time
        </span>
      </StyledButton>
      <StyledButton 
        asLink 
        title={getButtonTitle(props.userCalendarIsLocked)} 
        aria-disabled={props.userCalendarIsLocked} 
        onClick={() => {
          if (props.userCalendarIsLocked) return;
          props.openSchedulingWizardModal();
        }}>
        <span>
          <SemanticIcon name="magic" className={css['wand-icon']} />
          Scheduling Wizard
        </span>
      </StyledButton>
    </footer>
  );
}

WaitingRoomFooter.propTypes = {
  openAddOfficeHoursModal: PropTypes.func.isRequired,
  openAddAppointmentModal: PropTypes.func.isRequired,
  openAddWalkInModal: PropTypes.func.isRequired,
  openAddGroupSessionModal: PropTypes.func.isRequired,
  openReserveTimeModal: PropTypes.func.isRequired,
  openSchedulingWizardModal: PropTypes.func.isRequired,
  userCalendarIsLocked: PropTypes.bool.isRequired,
  managesUnlockedCalendar: PropTypes.bool.isRequired,
}

export default WaitingRoomFooter;
